import React from "react";
import PropTypes from "prop-types";
import { useApp } from "../../context/AppState";
import { resolvePreviewIsMobile } from "../../helper";
import styles from "../../layouts/checkout-extension/shared/widget-only-extension-preview.module.css";

/**
 * Neutral canvas for Essential full-page editor previews
 * (popup / drawer / product-page strip) — no storefront page mock.
 *
 * @param {boolean} [fitContent] — product-page FBT / carousel grid use height: max-content;
 *   all other templates use height: 100vh.
 */
export default function WidgetOnlyCampaignPreview({
  children,
  fitContent = false,
}) {
  const {
    appState,
    isMobile: viewportIsMobile,
    previewDeviceIsMobile,
  } = useApp();
  const isMobile = resolvePreviewIsMobile(
    appState,
    viewportIsMobile,
    previewDeviceIsMobile
  );

  return (
    <div
      className={`${styles.root} ${fitContent ? styles.rootFitContent : ""} ${
        isMobile ? styles.mobile : ""
      }`.trim()}
      data-testid="widget-only-campaign-preview"
      data-preview-chrome="widget"
      data-preview-device={isMobile ? "mobile" : "desktop"}
      data-preview-height={fitContent ? "max-content" : "100vh"}
    >
      <div className={styles.canvas}>{children}</div>
    </div>
  );
}

WidgetOnlyCampaignPreview.propTypes = {
  children: PropTypes.node,
  fitContent: PropTypes.bool,
};
